import { Component, ElementRef, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { ContratoService, ConvenioService, DespesaService, FichaDespesaService, LicitacaoService } from 'administrativo-lib';
import { ProdutoService, ProdutoUnidadeService } from 'almoxarifado-lib';
import {
  BaseResourceFormComponent, Contrato, Convenio, DateFormatPipe,
  Despesa, EddyAutoComplete, Estoque, Exercicio, FavorecidoService, FichaDespesa, FuncaoService,
  GlobalService, Licitacao, LoginContabil, Modalidade, Pessoa, PessoaService, Prazo, PrioridadeRCMS, Rcms, RcmsCotacao,
  RcmsFavorecido, RcmsItem, Setor, SetorService
} from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { CompraService } from '../../compra/service/compra.service';
import { ModalidadeService } from '../../modalidade/service/modalidade.service';
import { PrazoService } from '../../prazo/service/prazo.service';
import { RcmsFavorecidorService } from '../service/rcms-favorecido.service';
import { RcmsItemService } from '../service/rcms-item.service';
import { RcmsService } from '../service/rcms.service';

type SaldoFixa = {
  dotacao?: number,
  reservado?: number,
  saldo?: number,
  empenhado?: number,
  liquidado?: number,
  pago?: number
}

declare var $: any;

@Component({
  selector: 'app-rcms-form',
  templateUrl: './rcms-form.component.html'
})
export class RcmsFormComponent extends BaseResourceFormComponent<Rcms, LoginContabil> {
  /**
   * Declaração de variáveis
   */
  public saldoFixa: SaldoFixa;
  public itens: RcmsItem[];
  public favorecidos: RcmsFavorecido[];

  public visualizarFicha: boolean = false;
  public visualizarExclusao: boolean = false;
  public tab: number = 1;
  public display = false;

  public listaPrioridade: PrioridadeRCMS[];

  /**
   * Auto completes
   */
  public pessoaAutoComplete: EddyAutoComplete<Pessoa>;
  public fichaAutoComplete: EddyAutoComplete<FichaDespesa>;
  public subElementoAutoComplete: EddyAutoComplete<Despesa>;
  public licitacaoAutoComplete: EddyAutoComplete<Licitacao>;
  public convenioAutoComplete: EddyAutoComplete<Convenio>;
  public modalidadeAutoComplete: EddyAutoComplete<Modalidade>;
  public prazoAutComplete: EddyAutoComplete<Prazo>;
  public setorAutoComplete: EddyAutoComplete<Setor>;


  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    public globalService: GlobalService,
    public funcaoService: FuncaoService,
    protected favorecidoService: FavorecidoService,
    protected despesaService: DespesaService,
    protected fichaService: FichaDespesaService,
    protected licitacaoService: LicitacaoService,
    protected contratoService: ContratoService,
    protected convenioService: ConvenioService,
    protected modalidadeService: ModalidadeService,
    protected produtoService: ProdutoService,
    protected pessoaService: PessoaService,
    protected produtoUnService: ProdutoUnidadeService,
    private setorService: SetorService,
    private prazoService: PrazoService,
    private compraService: CompraService,
    protected rcmsItemService: RcmsItemService,
    protected rcmsFavorecidoService: RcmsFavorecidorService,
    protected rcmsService: RcmsService) {
    super(new Rcms(), injector, Rcms.converteJson, rcmsService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      data_rcms: [new Date(), [Validators.required]],
      data_entrega: [null, [Validators.required]],
      data_pagamento: [null, [Validators.required]],
      prioridade: [null],
      numero: [null, [Validators.required]],
      justificativa: [null],
      observacao: [null],
      documento: [null],
      modalidade: [null],
      ficha: [null, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]],
      exercicio: [this.login.exercicio, [Validators.required]],
      subelemento: [null, [Validators.required]],
      prazo: [null, [Validators.required]],
      setor: [null, [Validators.required]],
      licitacao: this.fb.group({
        id: [null],
        numero: [null]
      }),
      processo: [null],
      contrato: this.fb.group({
        id: [null],
        numero: [null],
      }),
      convenio: [null],
      usuario: [this.login.usuario],
      itens: [null],
      favorecidos: [null],
      requerente: [null, [Validators.required]]
    });
  }

  protected parametrosExtras(): {} {
    return {
      relations: ['setor', 'licitacao', 'contrato', 'exercicio', 'orgao', 'ficha',
        'ficha.despesa', 'subelemento', 'requerente', 'modalidade', 'prazo']
    };
  }

  protected afterInit(): void {
    this.listaPrioridade = this.globalService.prioridadesRCMS();
    if (!this.login.usuario.estoque) {
      const estoque = new Estoque();
      estoque.id = -1;
      this.login.usuario.estoque = estoque;
      this.display = true;
      console.log(this.display);
    }
    this.carregarAutoCompletes();
    this.subElementoFiltrar();
    if (this.currentActionRoute === 'novo') {
      this.rcmsService.proximoNumeroOF(this.login.exercicio.id, this.login.orgao.id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.entidadeForm.get('numero').setValue(res);
        });
    }
  }

  public redirecionar() {
    this.router.navigate(['/rcms']);
  }

  protected campoFoco(): ElementRef {
    return null;
  }

  protected async afterLoad() {
    this.entidade.data_rcms = new DateFormatPipe().transform(this.entidade.data_rcms, []);
    this.entidade.data_pagamento = new DateFormatPipe().transform(this.entidade.data_pagamento, []);
    this.entidade.data_entrega = new DateFormatPipe().transform(this.entidade.data_entrega, []);

    this.buscarSaldoFixa();

    this.rcmsItemService.filtrar(1, -1, {
      relations: ['produto_unidade', 'produto_unidade.produto', 'produto_unidade.unidade',
        'cotacoes', 'cotacoes.rcmsFavorecido', 'cotacoes.rcmsFavorecido.favorecido'], 'rcms.id': this.entidade.id, orderBy: ['ordem$ASC', 'cotacoes.id$DESC']
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.itens = res ? res.content : new Array<RcmsItem>();
      }, error => toastr.warning(error.error.payload));

    this.rcmsFavorecidoService.filtrar(1, -1, { relations: ['favorecido'], 'rcms.id': this.entidade.id, orderBy: 'id$DESC' })
      .pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
        this.favorecidos = res ? res.content : new Array<RcmsFavorecido>();
      }, error => toastr.warning(error.error.payload));


    this.entidade.data_rcms = new DateFormatPipe().transform(this.entidade.data_rcms, []);

    this.prazoAutComplete.id = this.entidade?.prazo?.id;
    this.modalidadeAutoComplete.id = this.entidade?.modalidade?.id;
    this.fichaAutoComplete.id = this.entidade?.ficha?.numero;

    this.subElementoFiltrar(this.entidade.ficha.despesa.codigo.substring(0, 6));
    this.subElementoAutoComplete.id = this.entidade?.subelemento?.codigo;
    this.subElementoAutoComplete.atualizar(false);

    this.carregarLicitacao();
    this.carregarContrato(this.entidade.contrato, true);
  }

  protected beforeSubmit() {
    this.entidadeForm.get('itens').setValue(!this.itens ? null : this.itens.map((i) => {
      let item = Object.assign(i);
      item.cotacoes = !item.cotacoes ? null : item.cotacoes.map((c) => {
        let cotacao: RcmsCotacao = Object.assign(c);
        delete cotacao.rcmsItem;
        delete cotacao.rcmsFavorecido.cotacoes;
        return cotacao;
      })
      return item;
    }));
    this.entidadeForm.get('favorecidos').setValue(this.favorecidos);
  }

  protected afterSubmit(ent: Rcms) {
    let url: string = this.rcmsService.retornarRota();
    if (!this.limparTela && !url.includes('novo'))
      this.afterLoad();
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  private buscarSaldoFixa() {
    const exercicio: Exercicio = this.entidade.exercicio ? this.entidade.exercicio : this.entidadeForm.get('exercicio').value;
    const ficha: FichaDespesa = this.entidade.ficha ? this.entidade.ficha : this.entidadeForm.get('ficha').value;
    const dataCompra: Date = this.entidade.data_rcms ? this.entidade.data_rcms : this.entidadeForm.get('data_rcms').value;

    if (!ficha || !dataCompra || !exercicio)
      return;
    this.compraService.totalizadoresFicha(
      exercicio.id, this.login.orgao.id, ficha.id,
      String(this.funcaoService.converteDataSQL(new DateFormatPipe().transform(dataCompra, ['local']))))
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (data)
          this.carregarSaldoFixa(data);
      })
  }

  private carregarSaldoFixa(totalizadores: {
    comprado: number, empenhado: number, liquidado: number, pago: number, reservado: number,
    comprado_ficha: number, dotacao_ficha: FichaDespesa, creditado_ficha: number
  }) {
    if (!totalizadores)
      return;
    this.saldoFixa = {};

    this.saldoFixa.empenhado = totalizadores.empenhado;
    this.saldoFixa.liquidado = totalizadores.liquidado;
    this.saldoFixa.pago = totalizadores.pago;

    this.saldoFixa.dotacao = +totalizadores.dotacao_ficha + +totalizadores.creditado_ficha;
    this.saldoFixa.reservado = totalizadores.reservado;
  }

  private carregarAutoCompletes() {
    // autocomplete para favorecido
    this.pessoaAutoComplete = new EddyAutoComplete(this.entidadeForm.get('pessoa'), this.pessoaService,
      'id', ['nome'], { cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] }
    );
    this.fichaAutoComplete = new EddyAutoComplete(this.entidadeForm.get('ficha'), this.fichaService,
      'numero', ['ficha.despesa.codigo', 'ficha.despesa.nome'],
      { exercicio_id: this.login.exercicio.id, orgao_id: this.login.orgao.id, relations: 'despesa', orderBy: 'despesa.nome' },
      { number: ['numero'], text: ['despesa.codigo', 'despesa.nome'] },
      () => {
        const ficha: FichaDespesa = this.entidadeForm.get('ficha').value;
        if (!this.fichaAutoComplete.id)
          this.entidadeForm.get('ficha').setValue(null);
        if (ficha && (!this.entidade.ficha || this.entidade.ficha.id !== ficha.id)) {
          this.subElementoFiltrar(ficha.despesa.codigo.substring(0, 6));
        }
        this.alterarSubElemento();
        this.buscarSaldoFixa();
      }
    );

    this.licitacaoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('licitacao'), this.licitacaoService,
      'id', ['numero'], { orgao_id: this.login.orgao.id, orderBy: 'numero' }, { number: ['numero'] }
    );
    this.convenioAutoComplete = new EddyAutoComplete(this.entidadeForm.get('convenio'), this.convenioService,
      'id', ['numero', 'ano'], { orgao_id: this.login.orgao.id, orderBy: 'numero' }, { number: ['id', 'numero'] }
    );
    this.modalidadeAutoComplete = new EddyAutoComplete(this.entidadeForm.get('modalidade'), this.modalidadeService, 'id',
      ['codigo', 'nome'], { orderBy: 'codigo' }, { number: ['codigo'], text: ['nome'] });
    this.prazoAutComplete = new EddyAutoComplete(this.entidadeForm.get('prazo_entrega'), this.prazoService, 'id',
      ['nome'], { 'orgao.id': this.login.orgao.id }, { text: ['nome'] });
    this.setorAutoComplete = new EddyAutoComplete(this.entidadeForm.get('setor'), this.setorService, 'id',
      ['nome'], { 'estoques.estoque.id': this.login.usuario.estoque.id, 'orgao.id': this.login.orgao.id }, { text: ['nome', 'sigla'] });
  }

  private subElementoFiltrar(codigo?: string) {
    this.subElementoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('subelemento'), this.despesaService, 'codigo', ['nome'],
      Object.assign({}, { exercicio_id: this.login.exercicio.id, nivel: 6, orderBy: 'codigo', }, { ['codigo$like']: codigo + '%' }),
      { number: ['id', 'codigo'], text: ['nome'] }, () => {
        if (!this.subElementoAutoComplete.id) {
          this.entidadeForm.get('subelemento').setValue(null);
          this.alterarSubElemento(false);
        }
      });
  }

  private alterarSubElemento(atualizar: boolean = true) {
    const ficha: FichaDespesa = this.entidadeForm.get('ficha').value;
    if (ficha) {
      const fichaSubElemento: string = ficha.despesa.codigo.substring(0, 6);
      const subElemento: Despesa = this.entidadeForm.get('subelemento').value;
      if (!subElemento || fichaSubElemento !== subElemento.codigo.substring(0, 6)) {
        this.subElementoAutoComplete.id = fichaSubElemento;
        this.entidadeForm.get('subelemento').setValue(null);
      } else {
        this.subElementoAutoComplete.id = subElemento.codigo;
      }
    } else if (atualizar) {
      this.subElementoAutoComplete.id = null;
      this.subElementoAutoComplete.atualizar(false);
    }
  }

  public buscarContrato() {
    let contrato = this.entidadeForm.get('contrato').value;
    this.entidadeForm.get('contrato').patchValue(new Contrato());
    this.entidadeForm.get('licitacao').enable();
    this.entidadeForm.get('processo').enable();

    this.carregarLicitacao();

    if (!contrato.numero)
      return;
    this.contratoService.obter({
      orgao_id: this.login.orgao.id,
      'numero': contrato.numero,
      relations: ['licitacao', 'licitacao.modalidade', 'favorecido', 'itens', 'itens.produto_unidade',
        'itens.produto_unidade.produto', 'itens.produto_unidade.unidade']
    })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (data)
          this.carregarContrato(data);
        else
          toastr.warning('Contrato não encontrada!');

      }, error => toastr.error(error.error.payload));
  }

  public limparContrato() {
  }

  private carregarContrato(contrato: Contrato, init?: boolean) {
    if (!contrato)
      return;
    this.entidadeForm.get('contrato').patchValue(contrato);
    this.entidadeForm.get('processo').setValue(contrato.processo);
    if (contrato.licitacao) {
      this.entidadeForm.get('licitacao').patchValue(contrato.licitacao);
      if (contrato.licitacao.modalidade)
        this.entidadeForm.get('modalidade').setValue(contrato.licitacao.modalidade);
    }
    if (!init) {
      this.favorecidos = [];
      let favorecido = new RcmsFavorecido();
      favorecido.favorecido = contrato.favorecido;
      this.favorecidos.push(favorecido);
    }
    this.entidadeForm.get('licitacao').disable();
    this.entidadeForm.get('processo').disable();
    this.entidadeForm.get('modalidade').disable();
  }

  public carregarLicitacao() {
    this.entidadeForm.get('modalidade').enable();
    let licitacao = this.entidadeForm.get('licitacao').value;
    this.entidadeForm.get('licitacao').patchValue(new Licitacao());
    if (!licitacao.numero)
      return;
    this.licitacaoService.obter({
      numero: licitacao.numero,
      'orgao.id': this.login.orgao.id,
      relations: 'modalidade'
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (data) {
          this.entidadeForm.get('licitacao').patchValue(data);
          if (data.modalidade)
            this.entidadeForm.get('modalidade').setValue(data.modalidade);
          this.entidadeForm.get('modalidade').disable();
        } else {
          toastr.warning('Licitação não encontrada!');
        }
      }, (error) => toastr.error(error.error.payload));
  }

  public totalRCSM() {
    let saldo = 0.0;
    if (!this.itens)
      return saldo;
    for (let item of this.itens) {
      if (!item.cotacoes)
        continue;
      let menor = item.cotacoes.filter((c) => c.valor_unitario > 0).sort((a, b) => a.valor_unitario - b.valor_unitario)[0];
      if (menor)
        saldo += menor.valor_unitario * item.quantidade;
    }
    return saldo;
  }

  public carregarPessoa(pessoa: Pessoa) {
    this.entidadeForm.get('requerente').setValue(pessoa);
  }

  public selecionarTab(tab: number) {
    this.tab = tab;
  }
  public tabSelecionado(tab: number) {
    return this.tab === tab;
  }

}
